export default {
    'INSERIR_BANDEIRAS' (state, payload) {
     state.tipos = payload;
    }
}